import { Table } from "antd";

export default function StrategyStatsTable({ runs }) {
  function computeStats(runs) {
    const sorted = {
      options: [...runs.map((r) => r.options_optionValue)].sort(
        (a, b) => a - b,
      ),
      rsu: [...runs.map((r) => r.rsu_rsuValue)].sort((a, b) => a - b),
      total: [...runs.map((r) => r.options_optionValue + r.rsu_rsuValue)].sort(
        (a, b) => a - b,
      ),
    };

    const percentile = (arr, p) => {
      const idx = (p / 100) * (arr.length - 1);
      const lo = Math.floor(idx);
      const hi = Math.ceil(idx);
      return arr[lo] + (arr[hi] - arr[lo]) * (idx - lo);
    };

    const avg = (arr) => arr.reduce((s, v) => s + v, 0) / arr.length;
    const fmt = (v) => `$${Math.round(v).toLocaleString()}`;

    const rows = [
      {
        label: "P10",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [
            k,
            fmt(percentile(arr, 10)),
          ]),
        ),
      },
      {
        label: "P25",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [
            k,
            fmt(percentile(arr, 25)),
          ]),
        ),
      },
      {
        label: "P50",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [
            k,
            fmt(percentile(arr, 50)),
          ]),
        ),
      },
      {
        label: "P75",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [
            k,
            fmt(percentile(arr, 75)),
          ]),
        ),
      },
      {
        label: "P90",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [
            k,
            fmt(percentile(arr, 90)),
          ]),
        ),
      },
      {
        label: "Average",
        ...Object.fromEntries(
          Object.entries(sorted).map(([k, arr]) => [k, fmt(avg(arr))]),
        ),
      },
    ];

    return rows;
  }

  const rows = computeStats(runs);

  const columns = [
    {
      title: "Percentile",
      dataIndex: "label",
      key: "label",
      align: "center",
    },
    {
      title: "Options",
      dataIndex: "options",
      key: "options",
      align: "center",
    },
    {
      title: "RSUs",
      dataIndex: "rsu",
      key: "rsu",
      align: "center",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      align: "center",
    },
  ];

  const BOLD_ROWS = ["P50", "Average"];

  return (
    <Table
      columns={columns}
      dataSource={rows.map((r, i) => ({ ...r, key: i }))}
      pagination={false}
      size="small"
      onRow={(record) => ({
        style: BOLD_ROWS.includes(record.label) ? { fontWeight: "bold" } : {},
      })}
    />
  );
}
